import { Error as ErrorIcon } from '@mui/icons-material';
import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { useMemo, useRef, useState } from 'react';
import { EmptyState } from '@/components/EmptyState';
import { useGetTransactions } from '../../hooks/useGetTransactions';
import { COLUMNS } from './constants';

type DealTransactionsTableProps = { dealId: number };

export const DealTransactionsTable = ({ dealId }: DealTransactionsTableProps) => {
  const pageSize = 10; // Default page size
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize });
  const { transactions, totalCount, loading, error } = useGetTransactions({
    dealId: Number(dealId),
    page: paginationModel.page,
    perPage: paginationModel.pageSize,
  });

  // Memoize the rowCount to prevent the table from re-setting to 0 when the totalCount changes
  // Reference: https://mui.com/x/react-data-grid/pagination/
  const rowCountRef = useRef(totalCount || 0);
  const rowCount = useMemo(() => {
    if (totalCount !== undefined) {
      rowCountRef.current = totalCount;
    }
    return rowCountRef.current;
  }, [totalCount]);

  if (error) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center'>
        <EmptyState title='Failed to load transactions.' Icon={ErrorIcon} />
      </Box>
    );
  }

  return (
    <DataGrid
      loading={loading}
      rows={transactions}
      rowCount={rowCount}
      columns={COLUMNS}
      disableColumnMenu
      paginationMode='server'
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      disableRowSelectionOnClick
      pageSizeOptions={[pageSize]}
    />
  );
};
